//summary of everything
import React, { useState, useEffect } from 'react';
import {  Row, Col } from 'react-bootstrap';
/*
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../../util/Api';
*/
import {Bar, Pie} from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, PointElement, LinearScale, BarElement, CategoryScale, Title, Tooltip, Legend } from 'chart.js';
import {  getColors, roundNum } from '../../../util/ChartUtils';

//TODO: add latency chart
ChartJS.register(ArcElement, Tooltip, Legend);

const ModelCharts = (props) => {

    let aggData = props.data;
    //let range = props.range;

    /*
    const [errors, setErrors] = useState([]);
    const [app, setApp] = useState(null);
    const [aggData, setAggData] = useState([]);

    const [range, setRange] = useState(null);

    const [startDatePicker, setStartDatePicker] = useState(null);
    const [endDatePicker, setEndDatePicker] = useState(null);
    const [showPicker, setShowPicker] = useState(false);

    const [datesForLink, setDatesForLink] = useState('');

    const [searchParams] = useSearchParams();

    let navigate = useNavigate();
    let { accountKey, appKey, startFactDate, endFactDate } = useParams();
    */

    const InteractionPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //sort 
        //data.sort((a, b) => (a.interactions < b.interactions) ? 1 : -1)

        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.interactions
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Interactions</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'interactions',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }
    const CostPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //data.sort((a, b) => (a.totalCost < b.totalCost) ? 1 : -1)

        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.totalCost
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>${roundNum(total, 6)} Cost</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'cost',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ],
                    }
                } 
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx) => {
                                    //console.log('hello')
                                    return ctx.dataset.label + ': ' + roundNum(ctx.parsed,6)
                                }
                            }
                        }
                    }
                }} />
            </div>
        )
    }
    const PromptsPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //sort 
        //data.sort((a, b) => (a.promptsIn < b.promptsIn) ? 1 : -1)

        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.promptsIn
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Prompts</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'prompts',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }
    const ResponsesPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //sort 
        //data.sort((a, b) => (a.promptsIn < b.promptsIn) ? 1 : -1)

        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.responsesOut
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Responses</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'responses',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }
    const TotalTokenPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //data.sort((a, b) => (a.totalTokens < b.totalTokens) ? 1 : -1)
        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.totalTokens
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Total Tokens</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'tokens',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }
    const PromptTokenPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //data.sort((a, b) => (a.promptTokens < b.promptTokens) ? 1 : -1)
        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.promptTokens
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Prompt Tokens</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'tokens',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }
    const CompletionTokenPieChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        //data.sort((a, b) => (a.completionTokens < b.completionTokens) ? 1 : -1)
        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.completionTokens
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Completion Tokens</div>
                <Pie data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'tokens',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    responsive: true,
                    plugins: {
                        legend : {
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'bottom',
                        }
                    }
                }} />
            </div>
        )

    }

    const TotalTokenBarChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        data.sort((a, b) => (a.totalTokens < b.totalTokens) ? 1 : -1)
        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.totalTokens
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>{total} Total Tokens</div>
                <Bar data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'tokens',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    indexAxis: 'y',
                    elements: {
                        bar: {
                        borderWidth: 2,
                        },
                    },
                    responsive: true,
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins: {
                        legend : {
                            display: false,
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'right',
                        }
                    }
                }} />
            </div>
        )

    }

    const TotalCostBarChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        data.sort((a, b) => (a.totalCost < b.totalCost) ? 1 : -1)
        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.totalCost
        ))
        let colors = getColors(data.length);
        let total = metrics.reduce((temp, x) => temp + x, 0);
        return (
            <div className='chart-card'>
                <div className='chart-title'>${roundNum(total, 6)} Total Cost</div>
                <Bar data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'cost',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    indexAxis: 'y',
                    elements: {
                        bar: {
                        borderWidth: 2,
                        },
                    },
                    responsive: true,
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins: {
                        legend : {
                            display: false,
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'right',
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx) => {
                                    return ctx.dataset.label + ': ' + roundNum(ctx.parsed.x,6)
                                }
                            }
                        }
                    }
                }} />
            </div>
        )

    }

    const AvgLatencyBarChart = (props) => {
        let data = props.data; 
        if(data == null || data.length < 1){
            return null;
        }
        data.sort((a, b) => (a.avgLatency < b.avgLatency) ? 1 : -1)
        let labels = data.map((elem, e) => (
            elem.model
        ))
        let metrics = data.map((elem, e) => (
            elem.avgLatency
        ))
        let colors = getColors(data.length);
        //let totalLatency = metrics.reduce((temp, x) => temp + x.latency, 0);
        //let totalInteractions = metrics.reduce((temp, x) => temp + x.interactions, 0);
        let totalLatency = 0;
        let totalInteractions = 0;
        data.forEach((item, i) => {
            totalLatency += item?.latency ? item.latency : 0;
            totalInteractions += item?.interactions ? item.interactions : 0;
        })
        let avg = totalInteractions > 0 ? (totalLatency/totalInteractions) : 0;
        //let total = metrics.reduce((temp, x) => temp + x, 0);

        return (
            <div className='chart-card'>
                <div className='chart-title'>{roundNum(avg,0)} Average Latency</div>
                <Bar data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'ms',
                                data: metrics,
                                backgroundColor: colors,
                            }
                        ]
                    }
                }
                options={{
                    indexAxis: 'y',
                    elements: {
                        bar: {
                        borderWidth: 2,
                        },
                    },
                    responsive: true,
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins: {
                        legend : {
                            display: false,
                            labels : {usePointStyle : true, boxHeight: 8}, 
                            position: 'right',
                        },
                        tooltip: {
                            callbacks: {
                                label: (ctx) => {
                                    return ctx.dataset.label + ': ' + roundNum(ctx.parsed.x,0)
                                }
                            }
                        }
                    }
                }} />
            </div>
        )

    }

    return (
            <>

                {
                    (Array.isArray(aggData) && aggData.length > 0) ? (
                        <>
                            
                            <Row sm={2}md={3} lg={3}>
                                <Col className='mb-5'>
                                    {/* show cost by model, tokens by model, interactions by model as three pie charts */}          
                                        <InteractionPieChart data={aggData}/>                                   
                                </Col>
                                <Col className='mb-5'>
                                     {/* show cost by model, tokens by model, interactions by model as three bar charts or list tokens, interactions by day over time period */}                         
                                        <PromptsPieChart data={aggData}/>
                                </Col>
                                <Col className='mb-5'>
                                        <ResponsesPieChart data={aggData}/>
                                </Col>
                                {/* 
                            </Row>
                            <Row sm={2}md={3} lg={3}>
                            */}
                                <Col className='mb-5'>
                                    <PromptTokenPieChart data={aggData}/>
                                </Col>
                                <Col className='mb-5'>
                                    <CompletionTokenPieChart data={aggData}/>
                                </Col>
                                <Col className='mb-5'>
                                    <TotalTokenPieChart data={aggData}/>              
                                </Col>
                            </Row>
                            
                            <Row md={2} lg={2}>
                                
                                <Col className='mb-5'>
                                <TotalCostBarChart data={aggData}/> 
                                </Col>
                                <Col className='mb-5'>
                                <AvgLatencyBarChart data={aggData}/> 
                                </Col>
                            </Row>
                        </>
                    ) : (
                        null
                    )
                }
        </>
    )
}

export default ModelCharts